import { useAuth } from "@/features/auth/auth-provider";

/** True only when the platform flag is on and the session is a Werkio platform admin. */
export function useCanAccessWorkerDocuments(): boolean {
  const { accessGate } = useAuth();
  return accessGate?.canAccessWorkerDocuments === true;
}

export function useIsPlatformAdmin(): boolean {
  const { accessGate } = useAuth();
  return accessGate?.platformRole === "PLATFORM_ADMIN" || accessGate?.isPlatformAdmin === true;
}
